// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2D3MP","active":"downloadDropdown_active__1ZR8q"};